export default [
  {
    key: 'FlowNodeSelectModal',
    getComponent: () => import('./FlowNodeSelectModal'),
    title: '',
    width: 700
  },
  {
    key: 'LimitFlowScopeModal',
    getComponent: () => import('./LimitFlowScopeModal'),
    title: '',
    width: 700
  },
  {
    key: 'TestModal',
    getComponent: () => import('./TestModal'),
    title: '',
    width: 700
  }
]
